export default __webpack_public_path__ + "static/media/template_business-man__0017_10---AlfredDec.2d81e52b.png";